"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var hoist_non_react_statics_1 = tslib_1.__importDefault(require("hoist-non-react-statics"));

var hooks_1 = require("./hooks");

function withI18n(i18nOptions) {
  return function (WrappedComponent) {
    function WithTranslations(props) {
      var _a = tslib_1.__read(hooks_1.useI18n(i18nOptions), 2),
          i18n = _a[0],
          ShareTranslations = _a[1];

      return react_1.default.createElement(ShareTranslations, null, react_1.default.createElement(WrappedComponent, tslib_1.__assign({}, props, {
        i18n: i18n
      })));
    }

    return hoist_non_react_statics_1.default(WithTranslations, WrappedComponent);
  };
}

exports.withI18n = withI18n;